export interface AsyncResult<T> {
  timeout: boolean;
  result?: T;
}

const asyncWithTimeout = async <T>(
  ms: number,
  asyncFunction: () => Promise<T>,
): Promise<AsyncResult<T>> => {
  const timeout = new Promise<AsyncResult<T>>((resolve) => {
    const id = setTimeout(() => {
      clearTimeout(id);
      resolve({ timeout: true });
    }, ms);
  });

  const promise = new Promise<AsyncResult<T>>((resolve, reject) => {
    asyncFunction()
      .then((result: T) => {
        resolve({
          result,
          timeout: false,
        });
      })
      .catch((e) => {
        reject(e);
      });
  });

  return Promise.race([promise, timeout]);
};

export default asyncWithTimeout;
